import React, { useEffect } from 'react';
import AboutSection from '../components/about/AboutSection';
import Mission from '../components/about/Mission';
import SEO from '../components/SEO';

const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const breadcrumbs = [
        { name: "Home", url: "/" },
        { name: "About Us", url: "/online-skill-development-courses-india" }
    ];

    const aboutSchema = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "About Skill Ascent | Leading Online Skill Development Institute India",
        "url": "https://www.skillascent.in/online-skill-development-courses-india",
        "description": "Learn about Skill Ascent's mission to bridge the gap between higher education and industry demands with high-impact certification training.",
        "mainEntity": {
            "@type": "EducationalOrganization",
            "name": "Skill Ascent",
            "url": "https://www.skillascent.in/"
        }
    };

    return (
        <>
            <SEO
                title="About Skill Ascent | Bridging Skill Gaps with Industry Certification Training"
                description="Skill Ascent is dedicated to empowering students, graduates and professionals with high-quality online certification training across IT, Agriculture, Engineering, Design, and Healthcare."
                keywords="About Skill Ascent, online training platform India, skill development institute, edtech certification, IT training institute, career transformation"
                canonicalPath="/online-skill-development-courses-india"
                schemaData={aboutSchema}
                breadcrumbs={breadcrumbs}
            />
            <AboutSection />
            <Mission />
        </>
    );

};

export default About;